import {
  add_coupon_failure,
  add_coupon_request,
  add_coupon_success,
  add_item_discount_failure,
  add_item_discount_request,
  add_item_discount_success,
  get_all_coupon_failure,
  get_all_coupon_request,
  get_all_coupon_success,
  get_all_item_discount_failure,
  get_all_item_discount_request,
  get_all_item_discount_success,
} from "../../reducers/admin/coupon";
import service from "../index";
/**This api is use for create a new coupon*/
export const add_coupon = (apiData) => async (dispatch) => {
  dispatch(add_coupon_request());
  return new Promise(async (resolve, reject) => {
    try {
      const res = await service.post("Coupon/CreateCoupon", apiData);
      resolve(res?.data);
      dispatch(add_coupon_success(res?.data));
    } catch (err) {
      reject(err?.data);
      dispatch(add_coupon_failure());
    }
  });
};

/**This api is use for delete a coupon*/
export const delete_coupon = (apiData) => async (dispatch) => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await service.post("Coupon/DeleteCoupon", apiData);
      resolve(res?.data);
    } catch (err) {
      reject(err?.data);
    }
  });
};

/**This api is use for active/deactive a coupon*/
export const active_coupon = (apiData) => async (dispatch) => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await service.post("Coupon/EnableCoupon", apiData);
      resolve(res?.data);
    } catch (err) {
      reject(err?.data);
    }
  });
};

/**This api  provided all list of coupon*/
export const get_all_coupon = (apiData) => async (dispatch) => {
  dispatch(get_all_coupon_request());
  return new Promise(async (resolve, reject) => {
    try {
      const res = await service.post("Coupon/GetAllCoupons", apiData);
      resolve(res?.data);
      dispatch(get_all_coupon_success(res?.data));
    } catch (err) {
      reject(err?.data);
      dispatch(get_all_coupon_failure());
    }
  });
};

/**This api is use for create a new per item discount*/
export const add_item_discount = (apiData) => async (dispatch) => {
  dispatch(add_item_discount_request());
  return new Promise(async (resolve, reject) => {
    try {
      const res = await service.post(
        "ItemDiscount/CreateItemDiscount",
        apiData
      );
      resolve(res?.data);
      dispatch(add_item_discount_success(res?.data));
    } catch (err) {
      reject(err?.data);
      dispatch(add_item_discount_failure());
    }
  });
};

/**This api  provided all list of coupon*/
export const get_all_item_discount = (apiData) => async (dispatch) => {
  dispatch(get_all_item_discount_request());
  return new Promise(async (resolve, reject) => {
    try {
      const res = await service.post(
        "ItemDiscount/GetAllItemDiscount",
        apiData
      );
      resolve(res?.data);
      dispatch(get_all_item_discount_success(res?.data));
    } catch (err) {
      reject(err?.data);
      dispatch(get_all_item_discount_failure());
    }
  });
};

/**This api is use for delete a coupon*/
export const delete_item_discount = (apiData) => async (dispatch) => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await service.post(
        "ItemDiscount/DeleteItemDiscount",
        apiData
      );
      resolve(res?.data);
    } catch (err) {
      reject(err?.data);
    }
  });
};

/**This api is use for active/deactive a coupon*/
export const active_item_discount = (apiData) => async (dispatch) => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await service.post(
        "ItemDiscount/EnableItemDiscount",
        apiData
      );
      resolve(res?.data);
    } catch (err) {
      reject(err?.data);
    }
  });
};
